<template lang="pug">
#modelAttr
  .title
    span 属性
    i.el-icon-close(@click='closeAdd')
  .content
    el-tree.attrtree(:data='treedatas' :props='defaultProps' empty-text='请点击选择构件' v-slot="{ node, data }")
      .custom-tree-node(:title='node.label') {{ node.label }}
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";

export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data () {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {
    treedatas() {
      return mongeApiMlib.getAttrTree();
    }
  },
  mounted() {
    mongeMutations.changeShowApp(false);
  },
  methods: {
    closeAdd() {
      this.$emit("closeCom", 'modelAttr', false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#modelAttr{
  position: fixed;
  bottom: 0;
  left: 0;
  top: 44px;
  z-index: 6;
  width: 260px;
  height: calc(100% - 44px);
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  .title{
    width: 100%;
    height: 40px;
    padding: 0 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #E5E8F1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    span{
      font-size: 17px;
      font-weight: 700;
    }
    i{
      font-size: 16px;
    }
  }
  .content{
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 10px 5px 0;
  }
}
</style>
